import Urologia from "..";

const routes = [
    { name: "VisitaList", path: "/paziente/urologia/visita", component: Urologia.Visita.VisitaList, meta: { title: "Visita" } },
    { name: "VisitaEdit", path: "/paziente/urologia/visita/edit/:id", component: Urologia.Visita.VisitaEdit, meta: { title: "Visita" } },
    { name: "VisitaView", path: "/paziente/urologia/visita/view/:id", component: Urologia.Visita.VisitaView, meta: { title: "Visita" } },
];

export default routes;